class ReferralForm {
	constructor (customer) {
		this.customer = customer;
	}

	initializeReferralForm() {
		if (this.customer.email === undefined) {
			$(".swell-share-links-container").css("display", "none");
			this.constructor.buildReferralForm("First, please submit your email below.", {name: "email", placeholder: "Your Email"}, {name: "submit", value: "NEXT"}, "referrerEmail");
			$(".referral-form").submit(SwellReferral.onReferrerInput);
		} else {
			$(".swell-share-links-container").css("display", "flex");
			this.constructor.buildReferralForm("Enter your friends' emails below.", {name: "referredEmails", placeholder: "Your Friends's Emails"}, {name: "submit", value: "SEND"}, "referralEmails");
			$(".referral-form").submit(SwellReferral.onReferralEmailsInput);
		}
	}

	static buildReferralForm(span, input, submit, inputClass) {
		$(".referral-form label").remove();
		$(".referral-form input[name=submit]").remove();
		$(".referral-form").append(
			$("<label>").append(
				$("<span>", {
					text: span
				}),
				$("<input>", {
					type: "text",
					name: input.name,
					placeholder: input.placeholder,
					required: "required"
				}).addClass(inputClass).on("keydown", () => $(".error").remove())
			),
			$("<input>", {
				type: "submit",
				name: submit.name,
				value: submit.value
			})
		)
	}

}